



























import {Vue, Component, Prop} from 'vue-property-decorator'
import Utils from '@/utils'
import {Invoice, WalletRecord} from '@/lib/kepler/interfaces'
import Sheet from '@/components/proxy/Sheet.vue'

@Component({
  components: {
    Sheet,

    Button: Utils.loadComponent('Button'),
    CardWithReport: Utils.loadComponent('CardWithReport'),
    CardDriver: Utils.loadComponent('CardDriver'),
    Layout: Utils.loadComponent('proxy/Layout'),
    Flex: Utils.loadComponent('proxy/Flex'),
    Container: Utils.loadComponent('proxy/Container'),
    StatusLabel: Utils.loadComponent('StatusLabel'),
  },
  name: 'WalletRecordDetail',
})
export default class WalletRecordDetail extends Vue {
  @Prop() public record!: WalletRecord

  public openInvoice(invoiceItem: Invoice) {
    cordova.InAppBrowser.open(invoiceItem.url, '_system')
  }
}
